<template>
  <div class="home">
    <!-- 筛选区域 -->
    <CategoryFilter 
      :categories="categories" 
      :selectedCategory="selectedCategory"
      @category-selected="filterByCategory"
    />

    <!-- 问题列表 -->
    <section class="question-list">
      <div v-if="loading" class="loading-indicator">
        <div class="flex flex-col items-center p-8">
          <div class="w-16 h-16 border-4 border-primary-300 border-t-primary-500 rounded-full animate-spin mb-4"></div>
          <p class="text-primary-600 font-semibold">加载中...</p>
        </div>
      </div>
      
      <div v-else-if="filteredQuestions.length === 0" class="no-questions bg-primary-50 border border-primary-200">
        <div class="flex flex-col items-center p-10">
          <svg class="w-16 h-16 text-primary-400 mb-4" fill="currentColor" viewBox="0 0 20 20">
            <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-3a1 1 0 00-.867.5 1 1 0 11-1.731-1A3 3 0 0113 8a3.001 3.001 0 01-2 2.83V11a1 1 0 11-2 0v-1a1 1 0 011-1 1 1 0 100-2zm0 8a1 1 0 100-2 1 1 0 000 2z" clip-rule="evenodd"></path>
          </svg>
          <p class="text-primary-600 font-semibold text-lg">没有找到相关问题</p>
          <p class="text-primary-500 mt-2">请尝试选择其他分类</p>
        </div>
      </div>
      
      <QuestionCard 
        v-else
        v-for="question in paginatedQuestions" 
        :key="question.id" 
        :question="question"
      />
    </section>

    <!-- 分页控件 -->
    <QuestionPagination 
      v-if="totalPages > 1"
      :currentPage="currentPage"
      :totalPages="totalPages"
      @page-changed="changePage"
    />
  </div>
</template>

<script>
import { fetchAllQuestions } from '@/api/questions'
import CategoryFilter from '@/components/CategoryFilter.vue'
import QuestionCard from '@/components/QuestionCard.vue'
import QuestionPagination from '@/components/Pagination.vue'

export default {
  name: 'HomeView',
  components: {
    CategoryFilter,
    QuestionCard,
    QuestionPagination
  },
  data() {
    return {
      questions: [],
      categories: [],
      selectedCategory: null,
      currentPage: 1,
      questionsPerPage: 5,
      loading: true
    }
  },
  computed: {
    // 根据分类筛选后的问题
    filteredQuestions() {
      if (!this.selectedCategory) {
        return this.questions;
      }
      return this.questions.filter(q => q.category === this.selectedCategory);
    },
    // 当前页要显示的问题
    paginatedQuestions() {
      const startIndex = (this.currentPage - 1) * this.questionsPerPage;
      const endIndex = startIndex + this.questionsPerPage;
      return this.filteredQuestions.slice(startIndex, endIndex);
    },
    // 总页数
    totalPages() {
      return Math.ceil(this.filteredQuestions.length / this.questionsPerPage);
    }
  },
  methods: {
    // 获取问题数据
    async fetchData() {
      this.loading = true;
      try {
        const data = await fetchAllQuestions();
        this.questions = data.questions;
        this.categories = data.categories;
      } catch (error) {
        console.error('Error loading questions:', error);
      } finally {
        this.loading = false;
      }
    },
    // 切换页码
    changePage(page) {
      if (page < 1 || page > this.totalPages) return;
      this.currentPage = page;
      // 滚动到页面顶部
      window.scrollTo(0, 0);
    },
    // 按分类筛选
    filterByCategory(category) {
      this.selectedCategory = category;
      this.currentPage = 1; // 重置为第一页
    }
  },
  created() {
    // 组件创建时获取数据
    this.fetchData();
  }
}
</script>

<style scoped>
.loading-indicator, .no-questions {
  text-align: center;
  padding: 50px 0;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}
</style> 